import React from "react";
import styled from "styled-components";

import Text from "../Text";

const Card = styled.div`
  -webkit-box-shadow: 1px 7px 18px -6px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 7px 18px -6px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 7px 18px -6px rgba(0, 0, 0, 0.75);
  border-radius: 30px;
  padding: 25px;
  margin-bottom: 30px;
`;
const CardHeader = styled.div`
  display: flex;
  flex-direcion: row;
  justify-content: space-between;
`;

export default (props) => {
  return (
    <Card>
      <CardHeader loading={props.loading}>
        <h3 className="text-capitalize">
          {props.loading ? (
            <i className="fas fa-spinner fa-pulse"></i>
          ) : (
            <Text>{props.title}</Text>
          )}
        </h3>
        <h3 className="text-capitalize">
          {props.loading ? (
            <i className="fas fa-spinner fa-pulse"></i>
          ) : (
            <Text>{props.amountValue}</Text>
          )}
        </h3>
      </CardHeader>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/_components/CardValue/index.jsx